import React, { useEffect } from 'react';
import './LegalPage.css';
import { ArrowLeft } from 'lucide-react';
import LandingNavbar from '../components/layout/LandingNavbar';

const PrivacyPolicy = ({ onNavigate, company }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-section-wrapper">
      <LandingNavbar company={company} onNavigate={onNavigate} view="privacy" />
      <div className="legal-container">
        <button className="legal-back-btn" onClick={() => onNavigate('home')}>
          <ArrowLeft size={16} />
          Back to Home
        </button>

        <div className="legal-header">
          <h1>Privacy Policy</h1>
          <p className="last-updated">Last Updated: April 17, 2026</p>
        </div>

        <div className="legal-section">
          <h2>1. Our Approach to Privacy</h2>
          <p>
            At BharatQA, we respect your data. We collect only what is necessary to connect developers with testers and generate quality bug reports. We do not sell your personal data to third parties or use it for intrusive advertising.
          </p>
        </div>

        <div className="legal-section">
          <h2>2. Information We Collect</h2>
          <p>Depending on how you use our platform, we collect the following:</p>
          <ul>
            <li><strong>Account Data:</strong> Your name, email address, and authentication details (e.g., Google OAuth).</li>
            <li><strong>Testing Telemetry:</strong> If you are a tester, we collect device models, location,OS versions, network conditions, crash logs, and screen recordings during active test sessions.</li>
            <li><strong>Payment Details:</strong> For testers to receive payouts, we securely collect payment destination info (like UPI IDs).</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>3. How We Use and Share Data</h2>
          <p>Your data is strictly used to operate and improve the BharatQA platform:</p>
          <ul>
            <li><strong>Client Delivery:</strong> App teams receive the device metadata, bug descriptions, and screen recordings generated by testers. They <strong>do not</strong> receive tester email addresses or payment details.</li>
            <li><strong>Platform Operations:</strong> We use secure, standard third-party cloud tools (like database hosts and video storage) to run the service. These vendors are strictly processors and do not own your data.</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>4. Security and Storage</h2>
          <p>
            We follow modern engineering practices to secure your data in transit and at rest. Please note, however, that no system on the internet can guarantee absolute 100% security.
          </p>
        </div>

        <div className="legal-section">
          <h2>5. Your Rights</h2>
          <p>
            You have the right to request access to, correction of, or deletion of your personal data. If you wish to close your account and have your corresponding personal profile removed from our systems, simply contact our team. (Note: historical test reports already delivered to clients cannot be retracted to maintain testing integrity.)
          </p>
        </div>

        <div className="legal-section">
          <h2>6. Contact Us</h2>
          <p>For any privacy-related inquiries, data requests, or issues, you can reach out directly to our team at <strong>bharatqa@fundup7.in</strong>.</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
